import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import Loading from '../components/Loading';
import SettingForm from '../components/SettingForm';
import { Select } from 'antd';

import { updateVoucher, updateMechanic, updateRegisterVoucher, updateBirthdayVoucher } from '../../../redux/actions/adminActions';

import axios from 'axios';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const mySwal = withReactContent(Swal);
const { Option } = Select;
// const options = []

class VoucherSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            loading: true,
            type: "Register",
            washerSetting: null,
            dryerSetting: null,
            combinedSetting: null,
            combined: false,
            specificStamp: "",
            stampTransactionAmount: 0,
            stamp: false,
            payAndGetRegVoucher: false,
            regVoucherAmount: 1,
            payAndGetBirthdayVoucher: false,
            birthdayVoucherAmount: 1,
            getAdminId: null,
            getAdminUsername: "",
            adminData: []
        };
    };

    componentDidMount() {
        if (!this.props.admin.isAuthenticated || !this.props.admin.admin) {
            return this.props.history.push('/admin/login');
        }
        else {
            if (this.state.type === "Stamp") {
                const washerVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Washer Stamp")[0]
                const dryerVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Dryer Stamp")[0]
                const combinedVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Combined Stamp")[0]
                this.setState({
                    ...this.state,
                    washerSetting: washerVoucherSetting,
                    dryerSetting: dryerVoucherSetting,
                    combinedSetting: combinedVoucherSetting,
                    loading: false,
                    combined: this.props.admin.admin.combined,
                    specificStamp: this.props.admin.admin.specificStamp,
                    stampTransactionAmount: this.props.admin.admin.stampTransactionAmount,
                    stamp: this.props.admin.admin.stamp,
                    payAndGetRegVoucher: this.props.admin.admin.payAndGetRegVoucher,
                    regVoucherAmount: this.props.admin.admin.regVoucherAmount,
                    payAndGetBirthdayVoucher: this.props.admin.admin.payAndGetBirthdayVoucher,
                    birthdayVoucherAmount: this.props.admin.admin.birthdayVoucherAmount
                });
            }
            else {
                const voucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === this.state.type)[0]
                this.setState({
                    ...this.state,
                    washerSetting: null,
                    dryerSetting: null,
                    combinedSetting: voucherSetting,
                    loading: false,
                    combined: this.props.admin.admin.combined,
                    specificStamp: this.props.admin.admin.specificStamp,
                    stampTransactionAmount: this.props.admin.admin.stampTransactionAmount,
                    stamp: this.props.admin.admin.stamp,
                    payAndGetRegVoucher: this.props.admin.admin.payAndGetRegVoucher,
                    regVoucherAmount: this.props.admin.admin.regVoucherAmount,
                    payAndGetBirthdayVoucher: this.props.admin.admin.payAndGetBirthdayVoucher,
                    birthdayVoucherAmount: this.props.admin.admin.birthdayVoucherAmount
                });

                const operatorId = this.props.admin.admin.operatorId;
                const type = "Voucher Setting"
                axios
                    .post("/api/admin/setting/getAllAdminTypePermission", { operatorId, type }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                    .then(res => {
                        // options.length = 0;
                        // for (let i = 0; i < res.data.data.length; i++) {
                        //     options.push({ value: res.data.data[i].id, label: res.data.data[i].username })
                        // }
                        this.setState({ adminData: res.data.data });
                    })
                    .catch(err => mySwal.fire("Error", err.response.data.error, "error"));

                // console.log(this.state)
            }
        }
    };



    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleSelect = val => {
        if (this.state.type !== val) {
            if (val === "Stamp") {
                const washerVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Washer Stamp")[0]
                const dryerVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Dryer Stamp")[0]
                const combinedVoucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === "Combined Stamp")[0]
                this.setState({
                    ...this.state,
                    type: val,
                    washerSetting: washerVoucherSetting,
                    dryerSetting: dryerVoucherSetting,
                    combinedSetting: combinedVoucherSetting,
                    loading: false,
                    combined: this.props.admin.admin.combined,
                    specificStamp: this.props.admin.admin.specificStamp,
                    stampTransactionAmount: this.props.admin.admin.stampTransactionAmount,
                    stamp: this.props.admin.admin.stamp,
                    payAndGetRegVoucher: this.props.admin.admin.payAndGetRegVoucher,
                    regVoucherAmount: this.props.admin.admin.regVoucherAmount,
                    payAndGetBirthdayVoucher: this.props.admin.admin.payAndGetBirthdayVoucher,
                    birthdayVoucherAmount: this.props.admin.admin.birthdayVoucherAmount
                });
            } else {
                const voucherSetting = this.props.admin.admin.setting.filter(setting => setting.type === val)[0]
                this.setState({
                    ...this.state,
                    type: val,
                    washerSetting: null,
                    dryerSetting: null,
                    combinedSetting: voucherSetting,
                    loading: false,
                    combined: this.props.admin.admin.combined,
                    specificStamp: this.props.admin.admin.specificStamp,
                    stampTransactionAmount: this.props.admin.admin.stampTransactionAmount,
                    stamp: this.props.admin.admin.stamp,
                    payAndGetRegVoucher: this.props.admin.admin.payAndGetRegVoucher,
                    regVoucherAmount: this.props.admin.admin.regVoucherAmount,
                    payAndGetBirthdayVoucher: this.props.admin.admin.payAndGetBirthdayVoucher,
                    birthdayVoucherAmount: this.props.admin.admin.birthdayVoucherAmount
                });
            }
        }
    };

    handleCheckbox = (field, target) => {

        this.setState({
            ...this.state,
            [field]: {
                ...this.state[field],
                [target.id]: !this.state[field][target.id]
            }
        });
    };

    handleChange = (field, target) => {

        this.setState({
            ...this.state,
            [field]: {
                ...this.state[field],
                [target.id]: target.value
            }
        });
    };

    handleSettingSubmit = e => {
        e.preventDefault();
        mySwal.fire({
            title: "Confirmation",
            text: "Are you sure you want to change the admin voucher priority?",
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonText: "Yes",
            cancelButtonColor: "#d33"
        })
            .then(click => {
                if (this.state.getAdminId) {
                    if (click.isConfirmed && click.value) {
                        this.setState({
                            ...this.state,
                            loading: true
                        });

                        const adminIdChange = this.state.getAdminId;
                        // console.log(adminIdChange)
                        const type = "Voucher Setting"
                        axios
                            .post("/api/admin/setting/updateAdminTypePriority", { adminIdChange, type }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                            .then(res => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire("Success", "The admin voucher priority successfully!", "success");
                            })
                            .catch(err => mySwal.fire("Error", err.response.data.error, "error"));
                    }
                }
                else {
                    mySwal.fire("Error", "Please select the admin ID", "error");
                }

            })
    }

    getAdminInfo = (value, label) => {
        // console.log(`selected ${value} &  ${label}`);
        this.setState({
            ...this.state,
            getAdminId: value,
            // getAdminUsername: label
        })
    };

    handleCombined = e => this.setState({
        ...this.state,
        combined: !this.state.combined
    });

    handlePayAndGetRegVoucher = e => this.setState({
        ...this.state,
        payAndGetRegVoucher: !this.state.payAndGetRegVoucher
    });

    handlePayAndGetBirthdayVoucher = e => this.setState({
        ...this.state,
        payAndGetBirthdayVoucher: !this.state.payAndGetBirthdayVoucher
    });

    submitCombined = e => {
        e.preventDefault();
        if (this.props.admin.admin.combined !== this.state.combined || this.props.admin.admin.specificStamp !== this.state.specificStamp || this.props.admin.admin.stampTransactionAmount !== this.state.stampTransactionAmount) {
            mySwal.fire({
                title: "Confirmation",
                text: "Are you sure you want to change how the stamping mechanics works?",
                icon: "question",
                showCancelButton: true,
                cancelButtonText: "No",
                confirmButtonText: "Yes",
                cancelButtonColor: "#d33"
            })
                .then(click => {
                    if (click.isConfirmed && click.value) {
                        this.setState({
                            ...this.state,
                            loading: true
                        });

                        const operatorId = this.props.admin.admin.operatorId;
                        const { combined, specificStamp, stampTransactionAmount } = this.state;

                        const sendThis = {
                            id: operatorId,
                            role: "operator",
                            combined,
                            specificStamp,
                            stampTransactionAmount
                        };

                        axios.post('/api/admin/setting/setCombined', sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                            .then(res => {
                                this.props.updateMechanic(res.data);
                                this.setState({
                                    ...this.state,
                                    loading: false,
                                    combined: res.data.combined,
                                    specificStamp: res.data.specificStamp,
                                    stampTransactionAmount: res.data.stampTransactionAmount
                                });
                                mySwal.fire("Success", "The stamping mechanics setting has updated successfully!", "success");
                            })
                            .catch(err => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire("Error", err.response.data.error, "error");
                            });
                    }
                })
        }
    };

    handleSpecific = e => this.setState({
        ...this.state,
        specificStamp: e.target.value
    });

    handleStampTransactionAmount = e => this.setState({
        ...this.state,
        stampTransactionAmount: e.target.value
    });

    handleRegVoucherAmount = e => this.setState({
        ...this.state,
        regVoucherAmount: e.target.value
    });

    handleBirthdayVoucherAmount = e => this.setState({
        ...this.state,
        birthdayVoucherAmount: e.target.value
    });

    handleSubmit = e => {
        e.preventDefault();
        const { type, washerSetting, dryerSetting, combinedSetting, payAndGetRegVoucher, regVoucherAmount, payAndGetBirthdayVoucher, birthdayVoucherAmount } = this.state;
        const { operatorId } = this.props.admin.admin;

        const sendThis = {
            id: operatorId,
            role: "operator",
            type,
            washerSetting,
            dryerSetting,
            combinedSetting,
            payAndGetRegVoucher,
            regVoucherAmount,
            payAndGetBirthdayVoucher,
            birthdayVoucherAmount
        };

        this.setState({
            ...this.state,
            loading: true
        });

        axios.post('/api/admin/setting/update', sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    loading: false
                })
                this.props.updateVoucher(res.data.data);

                if (type === "Register") {
                    this.props.updateRegisterVoucher({ payAndGetRegVoucher, regVoucherAmount })
                } else if (type === "Birthday") {
                    this.props.updateBirthdayVoucher({ payAndGetBirthdayVoucher, birthdayVoucherAmount })
                }

                mySwal.fire({
                    title: "Success",
                    text: "Your outlet voucher setting has been updated successfully.",
                    icon: "success",
                    confirmButtonColor: "#ffd109"
                });
            })
            .catch(err => {
                console.log(err);
                mySwal.fire("Error", err.response.data.error, "error");
                this.setState({
                    ...this.state,
                    loading: false
                });
            });
    };


    render() {

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />

                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />

                    <div className="admin-content">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">Voucher Admin Settings</h5>
                            </div>
                            <div className="card-body">
                                <p>Upcoming user voucher will follow the <strong>choosen latest admin</strong> voucher setting </p>
                                <Select
                                    showSearch
                                    placeholder="Select an admin"
                                    style={{ width: "50%" }}
                                    value={this.state.getAdminId}
                                    onChange={this.getAdminInfo}
                                // options={options}
                                >
                                    {this.state.adminData.map(item => (
                                        <Option key={item.id} value={item.id} >{item.username}</Option>
                                    ))}

                                </Select>

                                <br />
                                <br />
                                <button className="btn btn-primary" type="button" onClick={this.handleSettingSubmit}>
                                    SUBMIT
                                </button>

                            </div>

                        </div>
                        <br />
                        {/* {
                            this.state.stamp ? (
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Mechanics Setting</h5>
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={this.submitCombined}>

                                            <div className="form-group">
                                                <label htmlFor="stampTransactionAmount">Minimum transaction amount for getting stamp : (RM)</label>
                                                <input type="number" id="stampTransactionAmount" name="stampTransactionAmount" value={this.state.stampTransactionAmount} onChange={this.handleStampTransactionAmount} min="0" step="any" required />
                                            </div>

                                            <div className="form-group">
                                                <p>Select User Stamping Mechanic</p>

                                                <p>
                                                    <label htmlFor="radio1">
                                                        <input type="radio" name="combined" id="radio1" className="with-gap" checked={this.state.combined === false} onChange={this.handleCombined} />
                                                        <span>Separated Stamping</span>
                                                    </label>
                                                </p>

                                                <p>
                                                    <label htmlFor="radio2">
                                                        <input type="radio" name="combined" id="radio2" className="with-gap" checked={this.state.combined === true} onChange={this.handleCombined} />
                                                        <span>Combined Stamping</span>
                                                    </label>
                                                </p>
                                            </div>

                                            {
                                                !this.state.combined
                                                    ? (
                                                        <div>
                                                            <p>Stamp for?</p>
                                                            <div className="d-flex">
                                                                <div className="form-group">
                                                                    <label htmlFor="both">
                                                                        <input type="checkbox" id="both" name="specificStamp" checked={this.state.specificStamp === "both"} value="both" onChange={this.handleSpecific} />
                                                                        <span>Both</span>
                                                                    </label>
                                                                </div>

                                                                <div className="form-group ms-5">
                                                                    <label htmlFor="washerOnly">
                                                                        <input type="checkbox" id="washerOnly" name="specificStamp" checked={this.state.specificStamp === "washerOnly"} value="washerOnly" onChange={this.handleSpecific} />
                                                                        <span>Washer Only</span>
                                                                    </label>
                                                                </div>

                                                                <div className="form-group ms-5">
                                                                    <label htmlFor="dryerOnly">
                                                                        <input type="checkbox" id="dryerOnly" name="specificStamp" checked={this.state.specificStamp === "dryerOnly"} value="dryerOnly" onChange={this.handleSpecific} />
                                                                        <span>Dryer Only</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    : null
                                            }

                                            <div>
                                                {
                                                    this.state.loading
                                                        ? (
                                                            <div className="text-center">
                                                                <div className={`spinner-border text-${process.env.REACT_APP_STORETYPE === "cuci" ? "warning" : "primary"}`} role="status">
                                                                    <span className="sr-only">Loading...</span>
                                                                </div>
                                                            </div>
                                                        )
                                                        : <input type="submit" value="SUBMIT" className="btn btn-block btn-warning big-button" disabled={this.props.admin.admin.combined === this.state.combined && this.props.admin.admin.specificStamp === this.state.specificStamp && this.props.admin.admin.stampTransactionAmount === this.state.stampTransactionAmount} />
                                                }
                                            </div>
                                        </form>
                                        <div className="mt-5">
                                            <p><small>* Separated Stamping = Different washer and dryer stamp collection. (example: Using Washer will gain 1 washer's stamp, and Dryer will gain 1 dryer stamp)</small></p>
                                            <p><small>* Combined Stamping = Washer and dryer has the same collection. (example: Using Washer or Dryer will gain 1 stamp)</small></p>
                                        </div>
                                        {
                                            !this.state.combined
                                                ? (
                                                    <div>
                                                        <p><small>Stamp for : <strong>{this.state.specificStamp === "both" ? "Both" : this.state.specificStamp === "washerOnly" ? "Washer Only" : "Dryer Only"}</strong></small></p>
                                                        <p><small>* {this.state.specificStamp === "both" ? "User will be able to collect both washer stamp and dryer stamp" : `User will only able to collect ${this.state.specificStamp === "washerOnly" ? "Washer" : "Dryer"} stamp`}</small></p>
                                                    </div>
                                                )
                                                : null
                                        }
                                    </div>
                                </div>
                            ) : null
                        } */}

                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">Voucher Configuration</h5>
                            </div>

                            <div className="card-body">
                                <div>
                                    <ul className="nav nav-tabs m-auto">
                                        <li className="nav-item">
                                            <button onClick={e => this.handleSelect("Register")} className={this.state.type === "Register" ? "nav-link active font-weight-bold" : "nav-link"} style={{ backgroundColor: "white", outline: "none", borderBottom: this.state.type === "Register" ? null : "1px solid #dee2e6" }}>
                                                Registration
                                            </button>
                                        </li>

                                        {/* {
                                            this.state.stamp ? (
                                                <li className="nav-item">
                                                    <button onClick={e => this.handleSelect("Stamp")} className={this.state.type === "Stamp" ? "nav-link active font-weight-bold" : "nav-link"} style={{ backgroundColor: "white", outline: "none", borderBottom: this.state.type === "Stamp" ? null : "1px solid #dee2e6" }}>
                                                        Stamp
                                                    </button>
                                                </li>
                                            ) : null
                                        } */}

                                        <li className="nav-item">
                                            <button onClick={e => this.handleSelect("Birthday")} className={this.state.type === "Birthday" ? "nav-link active font-weight-bold" : "nav-link"} style={{ backgroundColor: "white", outline: "none", borderBottom: this.state.type === "Birthday" ? null : "1px solid #dee2e6" }}>
                                                Birthday
                                            </button>
                                        </li>
                                    </ul>

                                    <div className="mt-5">
                                        {
                                            this.state.loading
                                                ? <Loading />
                                                : <SettingForm
                                                    selected={this.state.type}
                                                    washerSetting={this.state.washerSetting}
                                                    dryerSetting={this.state.dryerSetting}
                                                    combinedSetting={this.state.combinedSetting}
                                                    handleCheckbox={this.handleCheckbox}
                                                    handleChange={this.handleChange}
                                                    handleSubmit={this.handleSubmit}
                                                    handleSettingSubmit={this.handleSettingSubmit}
                                                    combined={this.props.admin.admin.combined}
                                                    payAndGetRegVoucher={this.state.payAndGetRegVoucher}
                                                    regVoucherAmount={this.state.regVoucherAmount}
                                                    handlePayAndGetRegVoucher={this.handlePayAndGetRegVoucher}
                                                    handleRegVoucherAmount={this.handleRegVoucherAmount}
                                                    payAndGetBirthdayVoucher={this.state.payAndGetBirthdayVoucher}
                                                    birthdayVoucherAmount={this.state.birthdayVoucherAmount}
                                                    handlePayAndGetBirthdayVoucher={this.handlePayAndGetBirthdayVoucher}
                                                    handleBirthdayVoucherAmount={this.handleBirthdayVoucherAmount}
                                                />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        admin: state.admin
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateVoucher: data => dispatch(updateVoucher(data)),
        updateMechanic: data => dispatch(updateMechanic(data)),
        updateRegisterVoucher: data => dispatch(updateRegisterVoucher(data)),
        updateBirthdayVoucher: data => dispatch(updateBirthdayVoucher(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherSetting);